import React from "react";
import { useState, useEffect } from "react";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import AppConstants from "../../../Constants/AppConstants";

const AddBezeichnung = (props) => {
  const {
    bezeichnungDetails,
    closeAddBezeichnungPopUpCallback,
    equipmentGrpName,
  } = props;
  const [bezeichnung, setBezeichnung] = useState("");
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  useEffect(() => {
    setBezeichnung(bezeichnungDetails ? bezeichnungDetails.bezeichnung : "");
  }, [props]);

  const bezeichnungAdd = (e) => {
    e.preventDefault();
    let BezeichnungDetails = {
      ID: bezeichnungDetails
        ? bezeichnungDetails.id
        : AppConstants.DEFAULT_GUID,
      Bezeichnung: bezeichnung.trim(),
    };
    setGlobalSpinner(true);
    bezeichnungDetails && bezeichnungDetails.id != ""
      ? commonUtils.setIsEdit(true)
      : commonUtils.setIsEdit(false);
    EquipmentGroupActions.AddOrUpdateEquipment(BezeichnungDetails);
  };

  function handlePopOverClose() {
    if (!bezeichnungDetails) {
      setBezeichnung("");
    }
    closeAddBezeichnungPopUpCallback();
  }
  return (
    <div
      className={`modal fade   ${equipmentGrpName ? "nestedPopover" : ""}`}
      id="addBezeichnung"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addBezeichnung"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div
        className={`modal-dialog   ${
          equipmentGrpName ? "nestedPopverMargin" : ""
        }`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addBezeichnung">
              {bezeichnungDetails
                ? localization.editEquipment
                : localization.addEquipment}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addBezeichnungModalClose"
              //     onClick={handlePopOverClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="bezeichnungAdd"
            autoComplete="off"
            onSubmit={bezeichnungAdd}
          >
            <div className="modal-body">
              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="equipment">
                  {localization.nameOfEquipment}
                </label>
                <input
                  type="text"
                  id="bezeichnung"
                  name="bezeichnung"
                  className="form-control"
                  required
                  placeholder={localization.nameOfEquipment}
                  value={bezeichnung}
                  onChange={(e) => {
                    e.preventDefault();
                    if (bezeichnung !== "") {
                      setBezeichnung(e.target.value);
                    } else {
                      setBezeichnung(e.target.value.trim());
                    }
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddBezeichnung;
